import { FC } from 'react';
import './App.css';
import Main from './containers/Main';

const App: FC = () => (
  <div className="App">
    <Main />
  </div>
);

export default App;
